module.exports = __webpack_public_path__ + "img/gi_bebashambatan.b16506d6.png";